import { render } from "./DiscountsConditionForm.vue?vue&type=template&id=25d5a3e8"
import script from "./DiscountsConditionForm.vue?vue&type=script&lang=js"
export * from "./DiscountsConditionForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__